module.exports = __webpack_public_path__ + "static/media/logo-dishub.987d83f3.jpeg";